/**
 * @desc 获取 token
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.walmartOrder.getToken.Params, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/getToken`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
